var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 62.625V2.375h45V51.25L43.256 62.625H9.5z",
    stroke: "#2D8CCB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.256 62.625V51.25h11.25m-18.75-37.506H31.06a2.816 2.816 0 0 0 0 5.631h1.882a2.816 2.816 0 0 1 0 5.631h-4.685m3.75 0v3.75m0-18.75v3.738m-15 22.506h30m-30 7.5h30m-30 7.5h15",
    stroke: "#2D8CCB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteMin);
export default __webpack_public_path__ + "static/media/quote-min.4f3915be552c67efc5a8864c88f2e4cd.svg";
export { ForwardRef as ReactComponent };